export default function () {
  return {
    restrict: "A",
    link: function (scope, elem) {
      elem.on("submit", function () {
        console.log('asasasas');
        var firstError = elem.find('input.error')[0];
        if (firstError) {
          firstError.focus();
        }
      });
    }
  };
}


// WEBPACK FOOTER //
// ./src/js/eshop/Directives/focus-on-error.js